import React, { useEffect } from 'react';
import { useParams } from 'react-router-dom';
import { Helmet } from 'react-helmet-async';
import { Calendar, User, ArrowLeft } from 'lucide-react';
import { Link } from 'react-router-dom';

const InsightDetail = () => {
  const { id } = useParams();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const insights = {
    1: {
      title: 'The Future of AI in Enterprise: Trends and Predictions for 2024',
      author: 'Dr. Sarah Chen',
      date: '2024-01-15',
      readTime: '8 min read',
      content: `
        <p>Artificial Intelligence continues to reshape the enterprise landscape, with 2024 marking a pivotal year for AI adoption across industries.</p>
        <h2>Key Trends Shaping Enterprise AI</h2>
        <p>The enterprise AI landscape is evolving rapidly with generative AI integration and governance frameworks.</p>
      `
    },
    2: {
      title: 'Zero Trust Security: A Comprehensive Guide for Modern Enterprises',
      author: 'Michael Rodriguez',
      date: '2024-01-12',
      readTime: '12 min read',
      content: `
        <p>Zero Trust architecture represents a fundamental shift in cybersecurity strategy, moving from perimeter-based security to identity-centric protection.</p>
        <h2>Core Principles of Zero Trust</h2>
        <p>Never trust, always verify. This principle forms the foundation of zero trust security architecture.</p>
      `
    },
    3: {
      title: 'Cloud Migration Strategies: Lessons from 500+ Enterprise Transformations',
      author: 'Jennifer Park',
      date: '2024-01-10',
      readTime: '10 min read',
      content: `
        <p>Cloud migration success depends on careful planning, stakeholder alignment, and phased implementation strategies.</p>
        <h2>Migration Approaches</h2>
        <p>Lift-and-shift, re-platforming, and cloud-native approaches each have their place in enterprise transformation.</p>
      `
    },
    4: {
      title: 'Digital Transformation ROI: Measuring Success in the Modern Enterprise',
      author: 'David Thompson',
      date: '2024-01-08',
      readTime: '6 min read',
      content: `
        <p>Measuring digital transformation ROI requires both quantitative metrics and qualitative assessments of organizational change.</p>
        <h2>Key Performance Indicators</h2>
        <p>Revenue growth, cost reduction, and customer satisfaction are primary indicators of transformation success.</p>
      `
    },
    5: {
      title: 'Industry 4.0: Manufacturing\'s Digital Revolution',
      author: 'Lisa Wang',
      date: '2024-01-05',
      readTime: '9 min read',
      content: `
        <p>Industry 4.0 technologies are transforming manufacturing through IoT, AI, and advanced automation systems.</p>
        <h2>Smart Manufacturing</h2>
        <p>Connected factories enable real-time monitoring, predictive maintenance, and optimized production processes.</p>
      `
    },
    6: {
      title: 'Machine Learning Operations: Building Scalable ML Pipelines',
      author: 'Alex Kumar',
      date: '2024-01-03',
      readTime: '11 min read',
      content: `
        <p>MLOps bridges the gap between machine learning development and production deployment at enterprise scale.</p>
        <h2>Pipeline Architecture</h2>
        <p>Automated ML pipelines ensure consistent model training, validation, and deployment processes.</p>
      `
    }
  };

  const insight = insights[id] || insights[1];

  return (
    <>
      <Helmet>
        <title>{insight.title} | AuVSys Insights</title>
      </Helmet>
      
      <div className="insight-detail">
        <div className="container">
          <Link to="/insights" className="back-link">
            <ArrowLeft size={20} />
            Back to Insights
          </Link>
          
          <article className="insight-content">
            <header>
              <h1>{insight.title}</h1>
              <div className="insight-meta">
                <div className="meta-item">
                  <User size={16} />
                  <span>{insight.author}</span>
                </div>
                <div className="meta-item">
                  <Calendar size={16} />
                  <span>{new Date(insight.date).toLocaleDateString()}</span>
                </div>
                <span className="read-time">{insight.readTime}</span>
              </div>
            </header>
            
            <div className="content" dangerouslySetInnerHTML={{ __html: insight.content }} />
          </article>
        </div>
      </div>
    </>
  );
};

export default InsightDetail;